import { Link } from 'react-router-dom';
import { AiMessage } from '@/store/ai-assistant.store';
import AiDataTable from './AiDataTable';

const TYPE_TO_PATH: Record<string, string> = {
  task: '/tasks',
  damage_assessment: '/damage-assessments',
  shelter: '/shelters',
  incident: '/incidents',
  supply_request: '/supply-requests',
};

interface AiAssistantMessageProps {
  message: AiMessage;
}

export default function AiAssistantMessage({ message }: AiAssistantMessageProps) {
  if (message.role === 'user') {
    return (
      <div className="flex justify-end mb-3">
        <div className="max-w-[80%] bg-purple-600 text-white rounded-lg px-4 py-2 text-sm">
          {message.content}
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-start mb-3">
      <div className="max-w-[90%] bg-surface-tertiary rounded-lg px-4 py-3 text-sm">
        <div className="text-gray-800 dark:text-gray-200 whitespace-pre-wrap">{message.content}</div>

        {message.data_table && (
          <AiDataTable headers={message.data_table.headers} rows={message.data_table.rows} />
        )}

        {message.references && message.references.length > 0 && (
          <div className="mt-2 pt-2 border-t border-gray-200 dark:border-gray-600">
            <div className="text-xs text-theme-tertiary mb-1">References:</div>
            <div className="flex flex-wrap gap-1">
              {message.references.map((ref, i) => {
                const basePath = TYPE_TO_PATH[ref.type] || '';
                return basePath ? (
                  <Link
                    key={i}
                    to={basePath + '/' + ref.id}
                    className="inline-flex text-xs px-2 py-0.5 rounded bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 hover:bg-purple-200 dark:hover:bg-purple-800/40"
                  >
                    {ref.label}
                  </Link>
                ) : (
                  <span
                    key={i}
                    className="inline-flex text-xs px-2 py-0.5 rounded bg-gray-200 dark:bg-gray-600 text-gray-600 dark:text-gray-300"
                  >
                    {ref.label}
                  </span>
                );
              })}
            </div>
          </div>
        )}

        {message.sources_queried && message.sources_queried.length > 0 && (
          <div className="mt-1 text-xs text-theme-tertiary">
            Sources: {message.sources_queried.join(', ')}
          </div>
        )}
      </div>
    </div>
  );
}
